import React from "react";
import { Alert, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppInfo } from "shared-ts-app-info";

/**
 * Displays guidance when the user completed authentication in an external mobile browser
 * and should return to the native app instead of continuing to browse here.
 */
export const ExternalMobileAuthBrowserNotice: React.FC = () => {
  const { t } = useTranslation("shared-ts-ui-identity");
  const appInfo = useAppInfo();
  const handleTryClose = () => {
    try {
      window.close();
    } catch (_) {
      // noop
    }
  };

  return (
    <Stack sx={{ p: 2, maxWidth: 480, mx: "auto" }} gap={2}>
      <Typography variant="h5" align="center">
        {t("You are logged in")}
      </Typography>
      <Alert severity="info" variant="outlined">
        {t("Close this browser to return to the {{appName}} app", {
          appName: appInfo.name,
        })}
      </Alert>
      <Typography variant="body2" color="text.secondary" align="center">
        {t(
          "If the app does not open automatically when you close this tab, ...",
          { appName: appInfo.name }
        )}
      </Typography>
      <Button variant="outlined" onClick={handleTryClose}>
        {t("Try closing this tab")}
      </Button>
    </Stack>
  );
};
